import {
  IconBike16,
  IconBus16,
  IconCompetitor16,
  IconInfrastructureScooter16,
  IconMapStreetcar16,
  IconMetroMsk16,
  IconParking16,
} from '@cian/ui-kit';

import { IMapRowsProps } from '../../../../../components/Map/parts/MapRows';
import { EOutsideTAInfrastructureType, ITAInfrastructure } from '../../../../../types/map';
import { getAvailableOutsideInfrastructureTypes } from '../../../helpers/transportAccessibility';

const INFRASTRUCTURE_TYPES: Record<
  EOutsideTAInfrastructureType,
  {
    text: string;
    IconComponent: React.FunctionComponent;
  }
> = {
  [EOutsideTAInfrastructureType.busStops]: {
    text: 'Автобусы',
    IconComponent: IconBus16,
  },
  [EOutsideTAInfrastructureType.tramStops]: {
    text: 'Трамваи',
    IconComponent: IconMapStreetcar16,
  },
  [EOutsideTAInfrastructureType.metro]: {
    text: 'Метро',
    IconComponent: IconMetroMsk16,
  },
  [EOutsideTAInfrastructureType.parking]: {
    text: 'Парковки',
    IconComponent: IconParking16,
  },
  [EOutsideTAInfrastructureType.bikeParking]: {
    text: 'Велопарковки',
    IconComponent: IconBike16,
  },
  [EOutsideTAInfrastructureType.chargingStations]: {
    text: 'Зарядки электромобилей',
    IconComponent: IconCompetitor16,
  },
  [EOutsideTAInfrastructureType.scooterParking]: {
    text: 'Парковка самокатов',
    IconComponent: IconInfrastructureScooter16,
  },
};

export const getOutsideRows = (
  transportAccessibilityInfrastructure: ITAInfrastructure | undefined,
): IMapRowsProps['items'] => {
  const availableInfrastructureTypes = getAvailableOutsideInfrastructureTypes(transportAccessibilityInfrastructure);

  return availableInfrastructureTypes.map(type => ({
    id: type,
    ...INFRASTRUCTURE_TYPES[type],
  }));
};
